
  import {
    Component,
    Vue
  } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';

  @Component({
    name: 'product-buy-history',
    components: {
      PageFooter
    }
  })
  export default class ProductBuyHistory extends Vue {
    private productKey = '';
    private supplierKey = '';
    private list: any = [1,1,1,1,1,1,1,,1,1,1,1];

    private toRecord() {
      this.$router.push({
        name: 'Product_History_Record'
      })
    }
  }
